export const FEATURES = [
  "Mostre profissionalismo",
  "Reduza suporte",
  "Fidelize seus clientes com um app feito com a cara do seu provedor",
  "Cores, nome, logo e tudo pronto em até 7 dias.",
];
